<template>
  <div class="hy-index">
    <div class="index-searchbox">
      <van-search
        v-model="searchValue"
        shape="round"
        background="#FFF"
        placeholder="输入关键字，搜索讲座"
        @search="onSearch"
      />
    </div>
    <!--列表-->
    <div class="index-list">
      <div class="rows">
        <h5 class="index-title">
          搜索结果
          <span>{{this.total}}条</span>
        </h5>
        <van-list v-model="loading" :finished="finished" :finished-text="moreText" @load="onLoad">
          <van-cell v-for="item in data" :key="item.id">
            <a class="more-link" :href="'/index/conference/template?id='+item.id">
              <div class="imgbox">
                <img :src="item.cover_url" alt />
                <span class="text_icon" v-if="item.status_str == '待发布'">{{item.status_str }}</span>
                <span class="text_icon icon_yellow" v-if="item.status_str == '已发布' || item.status_str == '报名中'">{{item.status_str }}</span>
                <span class="text_icon icon_black" v-else-if="item.status_str == '会议中'">{{item.status_str }}</span>
                <span class="text_icon icon_blue" v-else-if="item.status_str == '已结束'">{{item.status_str }}</span>
                <span class="text_icon icon_yellow" v-else-if="item.status_str == '未到报名时间'">{{item.status_str }}</span>
                <span class="text_icon icon_black" v-else-if="item.status_str == '报名截止'">{{item.status_str }}</span>
                <span class="text_icon icon_black" v-else>{{item.status_str }}</span>
              </div>
              <div class="textbox">
                <div class="title">
                  <h5>{{item.name}}</h5>
                  <span class="type"  v-if="item.type== 1">会议</span>
                  <span class="type"  v-else-if="item.type== 2">沙龙</span>
                  <span class="type"  v-if="item.type== 3">活动</span>
                  <!-- <span class="type">活动</span> -->
                </div>
                <div class="textinfo">
                  <span class="iconfont">&#xe67f;</span>
                  {{item.start_time,'Y-M-D'|formatDates}}~{{item.end_time,'Y-M-D'|formatDates}}
                </div>
                <div class="textinfo">
                  <span class="iconfont">&#xe64d;</span>
                  {{item.region}}&nbsp;{{item.specific_address}}
                </div>
              </div>
            </a>
          </van-cell>
        </van-list>
        <div class="hy_nolist" v-if="data.length == 0">
          <span class="iconfont">&#xe619;</span>
          <p>
            未搜索到“{{searchValue}}”相关内容
            <br />请尝试其他关键词
          </p>
        </div>
      </div>
    </div>
    <div class="index-list" v-if="data.length == 0">
      <div class="rows">
        <h5 class="index-title">会议推荐</h5>
        <van-list>
          <van-cell v-for="item in tuiList" :key="item.id">
            <a class="more-link" :href="'/index/conference/template?id='+item.id">
              <div class="imgbox">
                <img :src="item.cover_url" alt />
                <span class="text_icon" v-if="item.status_str == '待发布'">{{item.status_str }}</span>
                <span class="text_icon icon_yellow" v-if="item.status_str == '已发布' || item.status_str == '报名中'">{{item.status_str }}</span>
                <span class="text_icon icon_black" v-else-if="item.status_str == '会议中'">{{item.status_str }}</span>
                <span class="text_icon icon_blue" v-else-if="item.status_str == '已结束'">{{item.status_str }}</span>
                <span class="text_icon icon_yellow" v-else-if="item.status_str == '未到报名时间'">{{item.status_str }}</span>
                <span class="text_icon icon_black" v-else-if="item.status_str == '报名截止'">{{item.status_str }}</span>
                <span class="text_icon icon_black" v-else>{{item.status_str }}</span>
              </div>
              <div class="textbox">
                <div class="title">
                  <h5>{{item.name}}</h5>
                  <span class="type"  v-if="item.type== 1">会议</span>
                  <span class="type"  v-else-if="item.type== 2">沙龙</span>
                  <span class="type"  v-if="item.type== 3">活动</span>
                  <!-- <span class="type">活动</span> -->
                </div>
                <div class="textinfo">
                  <span class="iconfont">&#xe67f;</span>
                  {{item.start_time,'Y-M-D'|formatDates}}~{{item.end_time,'Y-M-D'|formatDates}}
                </div>
                <div class="textinfo">
                  <span class="iconfont">&#xe64d;</span>
                  {{item.region}}&nbsp;{{item.specific_address}}
                </div>
              </div>
  </a>
          </van-cell>
        </van-list>
      </div>
    </div>
    <!--底部按钮-->
    <div class="hy-fixed-userBtn">
      <span class="iconfont fixed-link" @click="openFooterNav()">&#xe60c;</span>
      <div class="hy_footer_nav" :class="footerNav? 'active':''">
        <router-link class="nav-link iconfont" to="/">
          &#xe60e;
          <span class="text">会议平台首页</span>
        </router-link>
        <router-link class="nav-link iconfont" to="/myEnroll">
          &#xe609;
          <span class="text">我的会议信息</span>
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import { formatDates } from "../../assets/js/date";
export default {
  data() {
    return {
      /* 搜索关键字 */
      searchValue: "",
      /* 搜索数据 */
      data: [],
      /* 暂存搜索数据 */
      allList: [
      ],
      /* 推荐数据 */
      tuiList: [
      ],
      moreText:'没有更多了',
      loading: false,
      finished: false,
      footerNav: false,
      /* 页码 */
      page: 1,
      /* 每页条数 */
      pagesize: 5,
      /* 总页数 */
      total: 0
    };
  },
  created() {
    this.searchValue = this.$route.params.text;
    this.addList();
  },
  /* 时间过滤 */
  filters: {
    formatDates
  },
  methods: {
    //banner跳转方法
    goPath(path) {
      if (path == "") {
        return false;
      }
      this.$router.push(path);
    },
    //搜索方法
    onSearch(val) {
      if (val != "") {
        let _this = this;
        _this.page = 1;
        let url = "/ac1/conference/searchConference";
        let params = {
          page: _this.page,
          pagesize: _this.pagesize,
          keyword: val
        };
        _this.$get(url, params).then(res => {
          if(res.posts.list  == 0){
            _this.moreText = '';
          }
          _this.total = res.posts.count;
          _this.data = res.posts.list;
          _this.count = res.posts.count;
          _this.tuiList = res.posts.new_confe;
        });
      } else {
        this.$toast("请输入搜索内容");
      }
    },
    //热门咨询加载
    onLoad() {
      setTimeout(() => {
        var _this = this;
        _this.page++;
        let url = "/ac1/conference/searchConference";
        let params = {
          page: _this.page,
          pagesize: _this.pagesize,
          keyword: _this.searchValue
        };
        _this.$get(url, params).then(res => {
          if (res.code == "1") {
            if(res.posts.list  == 0){
              _this.moreText = '';
            }
            _this.allList = res.posts.list;
            _this.total = res.posts.count;
            _this.allList.forEach(v => {
              _this.data.push(v);
            });
          }
        });
        // 加载状态结束
        _this.loading = false;
        // 数据全部加载完成
        if (_this.data.length >= _this.total) {
          _this.finished = true;
        }
      }, 500);
    },
    //初始化列表
    addList() {
      let _this = this;
      let url = "/ac1/conference/searchConference";
      let params = {
        page: _this.page,
        pagesize: _this.pagesize,
        keyword: _this.searchValue
      };
      _this.$get(url, params).then(res => {
        _this.data = res.posts.list;
        _this.tuiList = res.posts.new_confe;
        /* 总条数 */

        _this.total = res.posts.count;
        if (_this.data.length >= _this.total) {
          _this.finished = true;
        }
        console.log(res);
      });
    },
    //打开底部链接
    openFooterNav(val) {
      if (this.footerNav) {
        this.footerNav = false;
      } else {
        this.footerNav = true;
      }
    }
  }
};
</script>
<style lang="less" scoped>
</style>
